import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import Form from 'new-ui/Components/Form';
import {
  PopupTitle,
  PopupContent,
  PopupButton,
} from 'new-ui/Components/Popup';
import { QUESTION_ID } from 'modules/questionnaire/questionIds';
import { getQuestionnaireRoute } from 'functions/getQuestionnaireRoute';
import { mergeUser } from 'modules/user/utils';

const NO = 'NO';
const YES = 'YES';

const HasAnythingChanged = ({ closePopup }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data: profile } = useSelector((state) => state.profile);

  const [hasAnythingChanged, setHasAnythingChanged] = useState(null);

  const form = {
    inputs: {
      HasAnythingChanged: {
        type: 'radio',
        options: [
          {
            value: NO,
            title: t('med_info_uptodate.med_info_changed_popup_opt_one'),
          },
          {
            value: YES,
            title: t('med_info_uptodate.med_info_changed_popup_opt_two'),
          },
        ],
      },
    },
    data: {
      HasAnythingChanged: '',
    },
  };

  const handleChange = (data, name) => {
    setHasAnythingChanged(data?.[name] ?? null);
  };

  const save = async () => {
    if (hasAnythingChanged === YES) {
      closePopup();
      dispatch(push(getQuestionnaireRoute({ questionId: QUESTION_ID.disease_status })));
      return;
    }
    if (hasAnythingChanged === NO) {
      // rematch is according to DEV-2502
      app.handleUserUpdate({ data: mergeUser(profile, { personal: { isAnythingChangeUpdate: true } }) });
    }
    closePopup();
  };

  return (
    <div>
      <PopupTitle title={t('med_info_uptodate.med_info_changed_popup_lbl')} />
      <PopupContent>
        <Form inputs={form.inputs} data={form.data} onChange={handleChange} />
      </PopupContent>
      <PopupButton
        title={t('med_info_uptodate.med_info_changed_popup_btn')}
        action={save}
        disabled={hasAnythingChanged === null}
      />
    </div>
  );
};

HasAnythingChanged.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default HasAnythingChanged;
